import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Configuration constants
  static DEFAULT_DURATION_MS = 10000  // 10 seconds
  static ANIMATION_DURATION_MS = 250  // 0.25 seconds
  static ANIMATION_CLASS_IN = 'animate-slide-in-right'
  static ANIMATION_CLASS_OUT = 'animate-fade-out-right'

  static values = {
    autohide: Boolean,
    duration: Number
  }

  connect() {
    // Animate in
    requestAnimationFrame(() => {
      this.element.classList.add(this.constructor.ANIMATION_CLASS_IN)
    })

    // Auto hide if enabled
    if (this.autohideValue) {
      const duration = this.durationValue || this.constructor.DEFAULT_DURATION_MS
      this.timeout = setTimeout(() => {
        this.close()
      }, duration)
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  close() {
    // Clear timeout if exists
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Animate out
    this.element.classList.remove(this.constructor.ANIMATION_CLASS_IN)
    this.element.classList.add(this.constructor.ANIMATION_CLASS_OUT)

    // Remove after animation
    setTimeout(() => {
      this.element.remove()
    }, this.constructor.ANIMATION_DURATION_MS)
  }
}